<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div>
              <div class="d-flex justify-space-between px-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      @click="$router.go(-1)"
                      icon
                      ><v-icon>mdi-reply</v-icon></v-btn
                    >
                  </template>
                  <span>Back</span>
                </v-tooltip>
              </div>
              <h3 style="text-align: center" class="mb-2">Activity History</h3>
            </div>
            <v-tabs centered color="green" slider-size="4" v-model="tab">
              <v-tab class="text-capitalize"> <b>Response</b> </v-tab>
            </v-tabs>
          </v-card>
        </div>
        <v-tabs-items v-model="tab" style="background: none">
          <v-tab-item class="pa-1">
            <list-response-event-micro-tsa />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import ListResponseEventMicroTsa from "./response/listResponseEventMicroTsa.vue";
export default {
  name: "tsaProposal",
  components: { ListResponseEventMicroTsa },
  data() {
    return {
      loading: true,
      loadingTextCover: false,
      loadingTextProposal: false,
      tab: null,
      editLinkCover: false,
      editLinkProposal: false,
      editLinkGuidelineCover: false,
      editLinkGuidelineProposal: false,
      dataSetCover: null,
      dataSetProposal: null,
      category: null,
      optTypeEvent: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/category`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optTypeEvent = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
